<template>
  <div>
    <Result />
  </div>
</template>
<script>
import Result from '@/components/Result';

export default {
  name: 'UserAllResults',
  components: {
    Result
  },
}
</script>